import { render, staticRenderFns } from "./editMaster.vue?vue&type=template&id=0654b40a"
import script from "./editMaster.vue?vue&type=script&lang=js"
export * from "./editMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports